const getDefaultState = () => {
	return {
		area_table: [],
		area_form: {
			province_code: null,
			regency_code: null,
		},
		province_options: [],
		regency_options: [],
		district_options: [],
	}
}

const default_state = getDefaultState()

export { default_state }